import {
  ArrowDownLeft,
  Ban,
  CircleAlert,
  CreditCard,
  Layers,
  type LucideIcon,
  QrCode,
  SendHorizontal,
  Undo2,
} from "lucide-react";

import type { DashboardAlertsTranslations } from "@/shared/lang/interfaces/dashboardAlerts";

import type { DashboardAlertGroup, DashboardAlertType } from "./dashboardAlertCatalog";

type AlertsKey = keyof DashboardAlertsTranslations;

/** What each alert, and each section, looks like wherever they are listed: Settings and the first-time card. */
export const DASHBOARD_ALERT_TYPE_ICON: Record<DashboardAlertType, LucideIcon> = {
  payins_breb_key: QrCode,
  payins_collections: ArrowDownLeft,
  payouts_paid: SendHorizontal,
  payouts_failed: CircleAlert,
  payout_batches_done: Layers,
  cards_purchase_approved: CreditCard,
  cards_purchase_declined: Ban,
  cards_refund: Undo2,
};

export const DASHBOARD_ALERT_GROUP_ICON: Record<DashboardAlertGroup, LucideIcon> = {
  payins: ArrowDownLeft,
  payouts: SendHorizontal,
  payout_batches: Layers,
  cards: CreditCard,
};

export const DASHBOARD_ALERT_GROUP_TITLE: Record<DashboardAlertGroup, AlertsKey> = {
  payins: "group_payins",
  payouts: "group_payouts",
  payout_batches: "group_payout_batches",
  cards: "group_cards",
};

export const DASHBOARD_ALERT_GROUP_SOUND_DESCRIPTION: Record<DashboardAlertGroup, AlertsKey> = {
  payins: "sound_desc_payins",
  payouts: "sound_desc_payouts",
  payout_batches: "sound_desc_payout_batches",
  cards: "sound_desc_cards",
};
